export default "__VITE_ASSET__D6ocX5BH__"